import React,{ FC } from "react";

import { FrontSide} from "../../atoms";
import { ICard } from "../../../interfaces";

interface CardProps {
    card: ICard
}

const Card: FC<CardProps> = ({card}) => {

    return (
        <React.Fragment>
            <FrontSide cardData={card} />
        </React.Fragment>
    );
}

export default Card;